






















































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { debounce } from 'lodash-es'
import constants from '@/utils/constants'
export interface IRemoteDataField {
  key: string
  label?: string
  sortable?: boolean
  class?: string
  formatter?: any
}

export class RemoteDataField implements IRemoteDataField {
  public key: string = ''
  public label?: string = ''
  public sortable?: boolean = true
  public class?: string = ''
  public formatter?: any = undefined

  constructor(remoteDataField?: IRemoteDataField) {
    if (remoteDataField) {
      this.key = remoteDataField.key ? remoteDataField.key : ''
      this.label = remoteDataField.label ? remoteDataField.label : ''
      this.sortable =
        remoteDataField.sortable || remoteDataField.sortable === undefined
      this.class = remoteDataField.class
        ? remoteDataField.class
        : 'text-center text-nowrap'
      this.formatter = remoteDataField.formatter
        ? remoteDataField.formatter
        : undefined
    }
  }
}

// @ts-ignore
@Component()
export default abstract class NewRemoteDataTable<T> extends Vue {
  // This overrides the parent component props on parent re-render so commented now. Still works normally.
  // @Prop(String) pageTitle!: string
  public constants: any = constants

  @Prop({
    type: Boolean,
    default: false
  })
  isSetting!: boolean

  @Prop({
    type: Boolean,
    default: true
  })
  isEdit!: boolean

  @Prop({
    type: Boolean,
    default: true
  })
  isDelete!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  readonly!: boolean

  // This overrides the parent component props on parent re-render so commented now. Still works normally.
  // @Prop(Array) fieldsSet!: Array<RemoteDataField>

  showSettingModal: boolean = false
  selectedSettingItem: any = null
  settingLoading: boolean = false
  showModal: boolean = false
  selectedItem: any = null
  perPage = 20
  perPageOptions: Array<number> = [10, 20, 50, 100]
  debounceFunction: any
  itemOption: Array<any> = []
  restaurantCode: Array<any> = []
  loginID: any = ''

  constructor(props: any) {
    super(props)
    this.debounceFunction = debounce(this.reload, 1000)
  }

  mounted() {
    this.reload()
  }

  limitPaging(page, total) {
    if (page < 6) {
      return 7
    }
    if (page > Math.ceil(total / this.perPage) - 5) {
      return 7
    }
    return 5
  }

  abstract get items(): T[]

  abstract get paging(): T[]

  abstract get sorting(): T[]

  abstract get filtering(): T[]

  resetSorting() {
    this.sortingChanged({ sortBy: '', sortDesc: '' })
  }

  resetFilter() {
    this.filterChanged(true)
  }

  abstract sortingChanged(ctx)

  abstract filterChanged(isResetFilter)

  abstract reload()

  abstract deleteItem(item)

  openSettingModal(outletCode) {
    if (outletCode) {
      this.settingLoading = true
      this.$store
        .dispatch('GetStorePin', outletCode)
        .then(res => {
          this.selectedSettingItem = {
            outlet_code: outletCode,
            ...res.data.data
          }
          this.showSettingModal = true
        })
        .finally(() => {
          this.settingLoading = false
        })
    }
  }

  discardSettingModal() {
    this.showSettingModal = false
    this.selectedSettingItem = null
  }

  openModal(id) {
    if (id) {
      this.$store.dispatch('GetOneStoreForNewPort', id).then(res => {
        this.selectedItem = res.data.result
        this.showModal = true
      })
    } else {
      this.showModal = true
    }
  }

  discardModal() {
    this.showModal = false
    this.selectedItem = null
  }

  cancelOrder(item) {
    this.$emit('cancel-order', item)
  }

  abstract setPerPage(page)

  onMaxEntriesChanged() {
    this.setPerPage(this.perPage)
  }

  get GetOneStoreForNewPort() {
    return this.$store.getters.GetOneStoreForNewPort
  }

  get isFetchingData() {
    return this.$store.getters.GetIsFetchingData
  }

  get isSettingRole() {
    return ['Admin', 'Management'].includes(this.$store.state.currentUser.Type)
  }

  beforeDestroy() {
    this.$store.commit('SET_IS_FETCHING_DATA', false)
  }
}
